import { BillerModel, initBillerModel } from '../../models/BillerModel';

const types = {
    SET_BILLER: 'SET_BILLER',
};

const initialState = {
    billInfo: initBillerModel(),
};

export const actions = {
    setBiller: async (dispatch: any, request: BillerModel) => {
        dispatch({
            type: types.SET_BILLER,
            payload: request,
        });
    },
};

export const billerReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.SET_BILLER:
            return {
                ...state,
                billInfo: action.payload,
            };
        default:
            return state;
    }
};
